import { NgxLoggerLevel } from "ngx-logger";

export const environment = {
  production: true,
  defaultLogLevel: NgxLoggerLevel.INFO,
  enableLoggingSourceMap: true,
  enablePercolatorCategorizationUi: true,
  api_url_padlock: "https://padlock.stress.concentrixcxs.com/v0",
  api_url_eared_dove: "https://dove.stress.concentrixcxs.com/v0",
  api_url_homing_pigeon: "wss://homing-pigeon.stress.concentrixcxs.com/socket",
  api_url_emperor_penguin: "https://penguin.stress.concentrixcxs.com/v0",
  api_url_king_penguin: "https://king-penguin.stress.concentrixcxs.com",
  api_url_flamingo: "https://flamingo.stress.concentrixcxs.com/v0",
  b2c_login_redirect_uri: "https://stress.concentrixcxs.com/",
};
